import React from 'react';

export const SimQuestion = ({bg, assets, ...props}) => {
  const next = (props.end === false) ? "question" : "segment";
  
  return (
    <fieldset className={`dinfos-sim-q${props.show ? ' dinfos-sim-q--active' : ''}`} data-question-no={props.index || props.index === 0 ? props.index + 1 : null} data-unscored={props.select_path ? true : null }>
      
      {/* Question */}
      <div className="dinfos-sim-q__head" style={bg && bg.src ? {backgroundImage:`url(${assets[bg.src]}`} : {}} data-src={bg && bg.src ? bg.src : null}>
        <legend className="dinfos-sim-q__question">
          <div className="dinfos-sim-q__count">Q. {props.count} OF {props.total}</div>
          <div className="dinfos-sim-q__bg">
            {props.background}
          </div>
          <div className="dinfos-sim-q__text">
            {props.text}
          </div>
        </legend>  
      </div>
      
      {/* Answer Choices */}
      <div className={`dinfos-sim-q__choices dinfos-drag-scroll-x dinfos-sim-q__choices--${props.format}`}>
        {!props.choices ? '' : props.choices.map((choice, choiceIndex) => {
          const choiceId = "choice-" + props.id + "-" + choiceIndex;
          const choiceType = "radio";
          return (
            <div key={choiceIndex} className={`custom-control custom-${choiceType} dinfos-choice`}>
              <input type={choiceType} className="custom-control-input" id={choiceId} name={props.id} value={choiceIndex} aria-describedby={`${choiceId}-feedback`} data-correct={ choice.correct ? true : null } aria-live="off" />
              <label className="custom-control-label" htmlFor={choiceId}>

                {props.format === "text" ?
                  choice.text
                : choice.image && choice.image.src ?
                  <img src={assets[choice.image.src]} alt={choice.image.alt} data-src={choice.image.src} />
                : ''}
              </label>

              {/* Feedback */}
              <div className="dinfos-choice__feedback" role="alert" aria-atomic="true">
                <div className="dinfos-choice__feedback-type">{ props.select_path ? 'Good Choice!' : choice.correct ? 'Correct!' : 'Incorrect!'}</div>
                <span>{choice.feedback ? choice.feedback : ''}</span>
                <span className="sr-only">Move on to the next {next}</span>
              </div>
            </div>
          )
        })}
      </div>
     
      {/* "Next" behaviors and buttons */}
      <div aria-live="polite">
        {props.select_path ?
          <>
            <button className="btn dinfos-btn dinfos-btn--primary mx-auto d-block" type="button" disabled data-make-selection>Submit</button>
            <button className="btn dinfos-btn dinfos-btn--primary mx-auto d-none" type="button" data-next data-start-path>Next Question</button>
          </>
        : 
          <>
            <button className="btn dinfos-btn dinfos-btn--primary mx-auto d-block" type="button" disabled data-check-answer>Submit</button>
            { props.end === false ?
              <button className="btn dinfos-btn dinfos-btn--primary mx-auto d-none" type="button" data-next data-next-question>Next Question</button>
            :
              <button className="btn dinfos-btn dinfos-btn--primary mx-auto d-none" type="button" data-next data-next-screen="true">Continue</button>
            }
          </>
        }
      </div>

    </fieldset>
  )
}